import React from 'react';
import { Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from 'components/common';
import { toggleModal } from 'data/actions/modals';
import { toggleMessage } from 'data/actions/message';
import {
  deleteAttachmentsFromStep,
  deleteAttachmentsFromTemplate,
  deleteAttachmentsFromThread,
} from 'data/actions/sequences';
import { deleteFilesFromStepLoaderSelector } from 'data/selectors/loading';
import { modalOptionsSelector, modalsSelector } from 'data/selectors/modals';
import { ModalTitle, CloseIcon, Footer } from '../baseModal/styles';

const DeleteFileFromStepModal = () => {
  const dispatch = useDispatch();

  const { visible } = useSelector(modalsSelector);
  const {
    threadId,
    stepId,
    version,
    attachment = {},
    previousModal,
    templateId,
    onDeleteFile,
    ...rest
  } = useSelector(modalOptionsSelector);
  const { _id: fileId, name: fileName, url: fileUrl } = attachment;

  const loading = useSelector(deleteFilesFromStepLoaderSelector);

  const handleClose = () => {
    if (previousModal) {
      dispatch(
        toggleModal(previousModal, true, {
          threadId,
          stepId,
          version,
          templateId,
          ...rest,
        }),
      );
    } else {
      dispatch(toggleModal('delete_file_from_step', false));
    }
  };

  const onSuccess = () => {
    dispatch(toggleMessage('success', { header: `File ${fileName} has been deleted` }));
    if (onDeleteFile) onDeleteFile(attachment);
    setImmediate(handleClose);
  };

  const handleDelete = () => {
    if (templateId) {
      dispatch(
        deleteAttachmentsFromTemplate({
          templateId,
          attachmentIds: [fileId],
          onSuccess,
        }),
      );
    } else if (stepId) {
      dispatch(
        deleteAttachmentsFromStep({
          stepId,
          attachmentIds: [fileId],
          version,
          onSuccess,
        }),
      );
    } else if (threadId) {
      dispatch(
        deleteAttachmentsFromThread({
          threadId,
          urls: [fileUrl],
          onSuccess,
        }),
      );
    }
  };

  return (
    <Modal
      visible={visible}
      title={
        <ModalTitle danger>
          Delete the file
          <CloseIcon onClick={handleClose} className="ic_close" />
        </ModalTitle>
      }
      closable={false}
      width={500}
      footer={false}
      onCancel={handleClose}
    >
      <div>
        <span>Are you sure you want to delete the file</span>
        &nbsp;
        <strong>{fileName}</strong>
        <span>?</span>
      </div>
      <Footer>
        <Button type="danger" size="large" data-form="true" loading={loading} onClick={handleDelete}>
          Delete
        </Button>
        <Button size="large" type="default" onClick={handleClose}>
          No
        </Button>
      </Footer>
    </Modal>
  );
};

export default DeleteFileFromStepModal;
